
import { Component, Vue, Prop } from 'vue-property-decorator'
import { StatusMap } from '../config/report'
import StatusDot from '@/components/status_dot/index.vue'
import MemoDialog from '@/views/user/components/memo.vue'
import { MediaService } from '@/services'

/**
 * @prop value  表格数据
*/
@Component({
    name: 'auth-table',
    components: {
        StatusDot,
        MemoDialog
    }
})
export default class extends Vue {
    @Prop({ required: true }) private value!: any[]

    private curMemo = ''
    private report: any = {}
    private statusOptions = [
        { key: 1, value: '未跟进' }, 
        { key: 2, value: '跟进中' }, 
        { key: 3, value: '跟进完成' }, 
        { key: 4, value: '无需跟进' }
    ]

    private get memoDialog() {
        return this.$refs.memoDialogRef as any
    }

    private getStatus(status: number, type: 'text' | 'status' | 'color') {
        const typeItem = StatusMap.get(status)
        if (!typeItem) return ''
        if (type === 'text') {
            return typeItem.value
        } else if (type === 'status') {
            return typeItem.status
        } else if (type === 'color') {
            return typeItem.color
        } else {
            return ''
        }
    }

    private async updateReport(params: any) {
        const result = await MediaService.updateReport(params)
        if (result.status === 200) {
            this.$message({ type: 'success', message: '设置成功' })
            return { status: true }
        }
        return {
            status: false,
            message: result.message
        }
    }

    private async onStatusSelect(status: any, item: any) {
        const { id: reportId } = item
        const params = { id: reportId, follow_status: status }
        const result = await this.updateReport(params)
        if (result.status) {
            item.follow_status = status
        }
    }

    private onEditMemo(report: any) {
        this.curMemo = report.follow_memo
        this.report = report
        this.memoDialog.show()
    }

    private async onUpdateInfo({ memo }: any) {
        const params = { id: this.report.id, follow_memo: memo }
        const { status, message } = await this.updateReport(params)
        if (status) {
            this.report.follow_memo = memo
        } else {
            this.$message({
                type: 'error',
                message: message || '修改发生错误',
                showClose: true
            })
        }
        this.memoDialog.close()
    }
}
